import React from "react"

export const HistoryTicket: React.FC<{ size?: number }> = ({ size = 48 }) => (
  <svg
    enable-background='new 0 0 64 64'
    id='Layer_1'
    height={`${size}px`}
    width={`${size}px`}
    version='1.1'
    viewBox='0 0 64 64'
    xmlSpace='preserve'
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
  >
    <g>
      <path d='M47.5,52c-1.1044922,0-2,0.8955078-2,2v5h-40V5h40v1c0,1.1044922,0.8955078,2,2,2s2-0.8955078,2-2V3   c0-1.1044922-0.8955078-2-2-2h-44c-1.1044922,0-2,0.8955078-2,2v58c0,1.1044922,0.8955078,2,2,2h44c1.1044922,0,2-0.8955078,2-2v-7   C49.5,52.8955078,48.6044922,52,47.5,52z' />
      <path d='M43.5,11c-10.4765625,0-19,8.5234375-19,19s8.5234375,19,19,19s19-8.5234375,19-19S53.9765625,11,43.5,11z M43.5,45   c-8.2714844,0-15-6.7290039-15-15s6.7285156-15,15-15s15,6.7290039,15,15S51.7714844,45,43.5,45z' />
      <path d='M46.1474609,29.6347656l3.0166016-4.5253906c0.6123047-0.9189453,0.3642578-2.1606445-0.5546875-2.7734375   c-0.9199219-0.6147461-2.1611328-0.3647461-2.7734375,0.5546875l-4,6   c-0.5615234,0.8417969-0.4052734,1.9697266,0.3623047,2.6279297l7,6C49.5751953,37.8417969,50.0380859,38,50.4990234,38   c0.5634766,0,1.1240234-0.2368164,1.5195313-0.6982422c0.71875-0.8388672,0.6220703-2.1015625-0.2167969-2.8203125   L46.1474609,29.6347656z' />
      <path d='M11.5,22h7c1.1044922,0,2-0.8955078,2-2s-0.8955078-2-2-2h-7c-1.1044922,0-2,0.8955078-2,2S10.3955078,22,11.5,22z' />
      <path d='M11.5,30h3c1.1044922,0,2-0.8955078,2-2s-0.8955078-2-2-2h-3c-1.1044922,0-2,0.8955078-2,2S10.3955078,30,11.5,30z' />
      <path d='M11.5,38h5c1.1044922,0,2-0.8955078,2-2s-0.8955078-2-2-2h-5c-1.1044922,0-2,0.8955078-2,2S10.3955078,38,11.5,38z' />
      <path d='M11.5,46h12c1.1044922,0,2-0.8955078,2-2s-0.8955078-2-2-2h-12c-1.1044922,0-2,0.8955078-2,2S10.3955078,46,11.5,46z' />
    </g>
  </svg>
)
